<div class="page-container" [attr.data-tenant-id]="tenantId || null" testId="quota-view-page">
  <div class="page-shell" testId="quota-view-shell">
    <nz-spin [nzSpinning]="false" testId="quota-view-spin">
      <div class="page-toolbar" testId="quota-view-toolbar">
        <div class="page-heading">
          <h1 class="page-title" testId="quota-view-title">{{ 'quota.view.title' | i18n }}</h1>
          <p class="page-subtitle">{{ 'quota.view.subtitle' | i18n }}</p>
        </div>
        <div class="toolbar-actions" *ngIf="pointBalance.entryUrl">
          <button
            nz-button
            nzType="default"
            class="toolbar-action-btn"
            (click)="openAction(pointBalance.entryUrl)"
            testId="quota-view-goto-aipool-button"
          >
            {{ 'quota.view.balance.goto-aipool' | i18n }}
          </button>
        </div>
      </div>

      <div class="form-container">
        <div class="quota-loading-state" *ngIf="loading" testId="quota-view-loading" aria-busy="true">
          <section class="quota-loading-hero">
            <div class="quota-loading-panel quota-loading-panel--wide">
              <div class="quota-loading-title-row">
                <div class="quota-loading-icon"></div>
                <div class="quota-loading-copy">
                  <div class="quota-loading-line quota-loading-line-title"></div>
                  <div class="quota-loading-line quota-loading-line-subtitle"></div>
                </div>
              </div>
              <div class="quota-loading-panel-grid">
                <div class="quota-loading-metric" *ngFor="let _ of loadingCardPlaceholders">
                  <div class="quota-loading-line quota-loading-line-sm"></div>
                  <div class="quota-loading-line quota-loading-line-value"></div>
                  <div class="quota-loading-line quota-loading-line-md"></div>
                </div>
              </div>
            </div>
          </section>

          <section class="quota-loading-content">
            <article class="quota-loading-card">
              <div class="quota-loading-card__header">
                <div class="quota-loading-copy">
                  <div class="quota-loading-line quota-loading-line-card-title"></div>
                  <div class="quota-loading-line quota-loading-line-md"></div>
                </div>
              </div>
              <div class="quota-loading-table">
                <div class="quota-loading-table__row" *ngFor="let _ of loadingRowPlaceholders">
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                </div>
              </div>
            </article>

            <article class="quota-loading-card">
              <div class="quota-loading-card__header">
                <div class="quota-loading-copy">
                  <div class="quota-loading-line quota-loading-line-card-title"></div>
                  <div class="quota-loading-line quota-loading-line-md"></div>
                </div>
              </div>
              <div class="quota-loading-table quota-loading-table--dense">
                <div class="quota-loading-table__row quota-loading-table__row--six" *ngFor="let _ of loadingRowPlaceholders">
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                  <div class="quota-loading-line quota-loading-line-cell"></div>
                </div>
              </div>
            </article>
          </section>
        </div>

        <div class="quota-view-page" *ngIf="!loading">
          <nz-card class="quota-table-card auth-card" *ngIf="authorization">
            <div class="auth-card__hero">
              <div class="auth-card__hero-badge">AI</div>
              <div>
                <div class="quota-section-head__title">{{ 'quota.view.authorization.title' | i18n }}</div>
                <div class="quota-section-head__meta auth-card__hero-meta">{{ 'quota.view.authorization.subtitle' | i18n }}</div>
              </div>
            </div>

            <div class="auth-panel">
              <div class="auth-overview" [class.auth-overview--single]="!showAuthorizedPointCard">
                <div class="auth-status" [class.auth-status--compact]="showPendingSection">
                  <div class="auth-status__main">
                    <div class="auth-status__head">
                      <div class="auth-status__icon">!</div>
                      <div class="auth-status__content">
                        <div class="auth-status__label">{{ 'quota.view.authorization.status-label' | i18n }}</div>
                        <div class="status-pill" [class]="'status-pill status-pill--' + getAuthorizationTone(authorization.status)">
                          {{ authorization.statusLabelKey | i18n }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="quota-section-head__actions auth-status__actions"
                      *ngIf="authorization.primaryAction || authorization.secondaryAction"
                    >
                      <button
                        nz-button
                        [nzType]="authorization.primaryAction.kind === 'primary' ? 'primary' : 'default'"
                        *ngIf="authorization.primaryAction"
                        [nzLoading]="authorizationActionLoading === authorization.primaryAction.action"
                        (click)="handleAuthorizationAction(authorization.primaryAction)"
                        testId="quota-view-authorization-primary-button"
                      >
                        {{ authorization.primaryAction.labelKey | i18n }}
                      </button>
                      <button
                        nz-button
                        nzType="default"
                        *ngIf="authorization.secondaryAction"
                        [nzLoading]="authorizationActionLoading === authorization.secondaryAction.action"
                        (click)="handleAuthorizationAction(authorization.secondaryAction)"
                        testId="quota-view-authorization-secondary-button"
                      >
                        {{ authorization.secondaryAction.labelKey | i18n }}
                      </button>
                    </div>
                  </div>
                  <div class="auth-status__desc">
                    {{ showPendingSection ? ('quota.view.authorization.pending-details-subtitle' | i18n) : authorization.description }}
                  </div>
                </div>

                <div class="point-balance-card" *ngIf="showAuthorizedPointCard">
                  <div class="point-balance-card__info">
                    <div class="point-balance-card__icon">✳</div>
                    <div class="point-balance-card__content">
                      <div class="point-balance-card__label">{{ 'quota.view.point-card.label' | i18n }}</div>
                      <div class="point-balance-card__value">
                        {{ formatNumber(pointBalance.ailePoint) }} <span>{{ 'quota.view.point-card.unit' | i18n }}</span>
                      </div>
                      <div class="point-balance-card__hint">{{ 'quota.view.point-card.hint' | i18n }}</div>
                    </div>
                  </div>
                  <button
                    nz-button
                    nzType="primary"
                    class="point-balance-card__action"
                    (click)="openPointPackagePurchase()"
                    testId="quota-view-point-balance-action-button"
                  >
                    {{ 'quota.view.point-card.buy-now' | i18n }}
                  </button>
                </div>
              </div>

              <div class="pending-summary pending-summary--spotlight" *ngIf="showPendingSection">
                <div class="pending-summary__head">
                  <div class="pending-summary__intro">
                    <div class="pending-summary__label">{{ 'quota.view.authorization.pending-summary-label' | i18n }}</div>
                    <div class="pending-summary__title">{{ 'quota.view.authorization.pending-summary-title' | i18n }}</div>
                  </div>
                  <div class="pending-summary__metrics">
                    <div class="pending-summary__metric">
                      <strong>{{ formatNumber(authorization.pendingCount) }}</strong>
                      <span>{{ 'quota.view.authorization.pending-summary-count-unit' | i18n }}</span>
                    </div>
                    <div class="pending-summary__metric">
                      <strong>{{ formatNumber(authorization.pendingPoints) }}</strong>
                      <span>{{ 'quota.view.authorization.pending-summary-points-unit' | i18n }}</span>
                    </div>
                  </div>
                </div>
                <div class="pending-summary__desc">{{ 'quota.view.authorization.pending-summary-desc' | i18n }}</div>
              </div>

              <div class="pending-details" *ngIf="showPendingSection && authorization.pendingItems.length">
                <div class="pending-details__head">
                  <div class="pending-details__heading">
                    <div class="pending-details__title">{{ 'quota.view.authorization.pending-details-title' | i18n }}</div>
                    <div class="pending-details__meta">
                      {{ authorization.pendingCount }} {{ 'quota.view.authorization.pending-summary-count-unit' | i18n }}
                    </div>
                  </div>
                  <button
                    nz-button
                    nzType="default"
                    class="pending-details__toggle"
                    (click)="togglePendingDetails()"
                    testId="quota-view-pending-details-toggle-button"
                  >
                    <span>{{ getPendingDetailsToggleLabel() }}</span>
                    <span nz-icon [nzType]="pendingDetailsExpanded ? 'up' : 'down'"></span>
                  </button>
                </div>

                <div class="pending-details__content" [class.pending-details__content--expanded]="pendingDetailsExpanded">
                  <div
                    class="quota-table quota-table--pending"
                    *ngIf="pendingDetailsExpanded && authorization.pendingItems.length; else noPendingTpl"
                  >
                    <div class="quota-table__header">
                      <div>{{ 'quota.view.table.time' | i18n }}</div>
                      <div>{{ 'quota.view.table.type' | i18n }}</div>
                      <div>{{ 'quota.view.table.points' | i18n }}</div>
                      <div>{{ 'quota.view.table.status' | i18n }}</div>
                    </div>
                    <div class="quota-table__row" *ngFor="let item of authorization.pendingItems">
                      <div [attr.data-label]="'quota.view.table.time' | i18n">{{ getPendingItemTimeLabel(item) }}</div>
                      <div [attr.data-label]="'quota.view.table.type' | i18n">
                        <div>{{ item.type }}</div>
                        <small *ngIf="item.note">{{ item.note }}</small>
                      </div>
                      <div [attr.data-label]="'quota.view.table.points' | i18n">{{ formatNumber(item.points) }}</div>
                      <div [attr.data-label]="'quota.view.table.status' | i18n">
                        <span class="status-pill status-pill--orange">{{ item.status }}</span>
                      </div>
                    </div>
                  </div>

                  <ng-template #noPendingTpl>
                    <div class="pending-details__empty" *ngIf="pendingDetailsExpanded">{{ 'quota.view.authorization.empty' | i18n }}</div>
                  </ng-template>
                </div>
              </div>
            </div>
          </nz-card>

          <ng-container *ngIf="hasQuotaGroups; else emptyQuotaTpl">
            <nz-card class="quota-table-card quota-group-card" *ngFor="let group of quotaGroups; let first = first">
              <div class="quota-section-head">
                <div>
                  <div class="quota-section-head__title">{{ group.title }}</div>
                  <div class="quota-section-head__meta">
                    <span *ngIf="first"
                      >{{ 'tenant.detail.quota-usage-tenant-name' | i18n }}: {{ detail?.tenantName || tenantName || '--' }}</span
                    >
                    <span *ngIf="first">{{ 'tenant.detail.quota-usage-plan-name' | i18n }}: {{ detail?.planName || '--' }}</span>
                    <span>{{ group.description }}</span>
                  </div>
                </div>
                <div class="quota-section-head__meta quota-section-head__meta--solo"
                  >{{ group.items.length }} {{ 'quota.view.group.item-count' | i18n }}</div
                >
              </div>

              <div class="quota-table">
                <div class="quota-table__header">
                  <div>{{ 'tenant.detail.quota-usage-table-name' | i18n }}</div>
                  <div>{{ 'tenant.detail.quota-usage-table-limit' | i18n }}</div>
                  <div>{{ 'tenant.detail.quota-usage-table-used' | i18n }}</div>
                  <div>{{ 'tenant.detail.quota-usage-table-remaining' | i18n }}</div>
                  <div>{{ 'tenant.detail.quota-usage-table-rate' | i18n }}</div>
                  <div>{{ 'tenant.detail.quota-usage-table-policy' | i18n }}</div>
                </div>
                <div class="quota-table__row" *ngFor="let item of group.items">
                  <div class="quota-table__name" [attr.data-label]="'tenant.detail.quota-usage-table-name' | i18n">
                    <div class="quota-table__primary">{{ item.quotaName || item.quotaCode || '--' }}</div>
                    <div class="quota-table__secondary" *ngIf="item.quotaCode">{{ item.quotaCode }}</div>
                    <div class="quota-table__marker" *ngIf="getQuotaHint(item)">{{ getQuotaHint(item) }}</div>
                  </div>
                  <div class="quota-table__cell" [attr.data-label]="'tenant.detail.quota-usage-table-limit' | i18n">
                    {{ formatQuotaValue(item.limitValue ?? item.freeLimitValue, item.unit) }}
                  </div>
                  <div class="quota-table__cell" [attr.data-label]="'tenant.detail.quota-usage-table-used' | i18n">
                    {{ formatUsedQuotaValue(item) }}
                  </div>
                  <div class="quota-table__cell" [attr.data-label]="'tenant.detail.quota-usage-table-remaining' | i18n">
                    {{ isPointDeductPolicy(item) ? '--' : formatQuotaValue(item.remainingValue, item.unit) }}
                  </div>
                  <div
                    class="quota-table__cell quota-table__usage-status"
                    [attr.data-label]="'tenant.detail.quota-usage-table-rate' | i18n"
                  >
                    <ng-container *ngIf="!isBroadcastPointDeductPolicy(item); else pointDeductTpl">
                      <div class="quota-table__usage-wrap">
                        <nz-progress
                          class="quota-table__progress"
                          [nzPercent]="getProgressPercent(item)"
                          [nzShowInfo]="false"
                          [nzStrokeColor]="getProgressStrokeColor(item.status)"
                          [nzStrokeWidth]="10"
                          nzSize="small"
                        />
                        <div class="quota-table__usage-meta">
                          <span class="quota-table__rate-value">{{ formatUsageRate(item.usageRate) }}</span>
                          <span class="status-pill" [class]="'status-pill status-pill--' + getStatusTone(item.status)">
                            {{ getStatusLabel(item.status) }}
                          </span>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #pointDeductTpl>
                      <div class="quota-table__usage-wrap quota-table__usage-wrap--special quota-table__usage-wrap--broadcast">
                        <span class="status-pill" [class]="'status-pill status-pill--' + getStatusTone(item.status)">
                          {{ 'tenant.detail.quota-usage-point-deduct-hint-default' | i18n }}
                        </span>
                      </div>
                    </ng-template>
                  </div>
                  <div class="quota-table__cell quota-table__policy" [attr.data-label]="'tenant.detail.quota-usage-table-policy' | i18n">
                    <span class="quota-table__policy-badge">{{
                      item.chargePolicyLabel || getChargePolicyLabel(item.chargePolicyType)
                    }}</span>
                  </div>
                </div>
              </div>
            </nz-card>
          </ng-container>

          <div class="retention-grid" *ngIf="retentionCards.length || numericAddonCards.length">
            <nz-card
              class="quota-table-card retention-card"
              [class.is-purchased]="card.preview?.mode === 'purchased'"
              [class.is-loading]="card.previewLoading"
              *ngFor="let card of retentionCards; let ri = index"
              [testId]="'quota-view-retention-card-' + ri"
            >
              <div class="quota-section-head">
                <div>
                  <div class="quota-section-head__title">
                    {{ card.title }}
                    <span class="retention-card__hero-badge" *ngIf="!card.previewLoading && card.preview?.mode === 'purchased'"
                      >已延長</span
                    >
                  </div>
                  <div class="quota-section-head__meta">{{ card.description }}</div>
                </div>
                <div class="retention-card__summary" *ngIf="!card.previewLoading && card.preview?.statusChips?.length">
                  <button
                    type="button"
                    class="retention-card__summary-chip"
                    *ngFor="let chip of card.preview?.statusChips; let ci = index"
                    [class.is-warning]="chip.tone === 'warning'"
                    [class.is-info]="chip.tone === 'info'"
                    (click)="openRetentionStatusSummary(card, chip)"
                    [testId]="'quota-view-retention-status-chip-' + ri + '-' + ci"
                  >
                    {{ chip.text }}
                  </button>
                </div>
              </div>
              <ng-container *ngIf="!card.previewLoading; else retentionCardLoadingTpl">
                <div class="retention-card__current" [class.is-purchased]="card.preview?.mode === 'purchased'">
                  <div class="retention-card__label">{{ card.currentHint }}</div>
                  <div class="retention-card__value">{{ card.currentValue }}</div>
                  <div class="retention-card__subvalue" *ngIf="card.preview?.mode === 'free'">(免費配額)</div>
                  <div class="retention-card__subvalue is-active" *ngIf="card.preview?.mode === 'purchased'">(已購買延長包)</div>
                </div>
                <div class="retention-card__preview" [class.is-free]="preview.mode === 'free'" *ngIf="card.preview as preview">
                  <ng-container *ngIf="preview.mode === 'free'; else purchasedRetentionPreviewTpl">
                    <div class="retention-card__options-banner" *ngIf="card.preview.availableOptions.length">
                      <span class="retention-card__options-banner-label">延長方案</span>
                      <div class="retention-card__chips is-inline">
                        <span class="retention-card__chip" *ngFor="let option of preview.availableOptions">{{ option }}</span>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #purchasedRetentionPreviewTpl>
                    <div class="retention-card__preview-top">
                      <span class="retention-card__status" [class.is-active]="preview.enabled">{{ preview.statusText }}</span>
                      <span class="retention-card__package">{{ preview.packageText }}</span>
                    </div>
                    <div class="retention-card__facts">
                      <div class="retention-card__fact">
                        <span class="retention-card__fact-label">延長包類型</span>
                        <span class="retention-card__fact-value">{{ preview.packageText }}</span>
                      </div>
                      <div class="retention-card__fact" *ngIf="preview.purchaseDateText">
                        <span class="retention-card__fact-label">購買日期</span>
                        <span class="retention-card__fact-value">{{ preview.purchaseDateText }}</span>
                      </div>
                      <div class="retention-card__fact" *ngIf="preview.expireDateText">
                        <span class="retention-card__fact-label">到期日期</span>
                        <span class="retention-card__fact-value">{{ preview.expireDateText }}</span>
                      </div>
                      <div class="retention-card__fact" *ngIf="preview.remainingDaysText">
                        <span class="retention-card__fact-label">剩餘天數</span>
                        <span class="retention-card__fact-value is-success">{{ preview.remainingDaysText }}</span>
                      </div>
                    </div>
                    <div class="retention-card__pending" *ngIf="preview.pendingText">
                      <span class="retention-card__pending-label">待生效</span>
                      <span class="retention-card__pending-value">{{ preview.pendingText }}</span>
                    </div>
                  </ng-template>
                </div>
                <button
                  nz-button
                  [nzType]="card.preview?.mode === 'purchased' ? 'default' : 'primary'"
                  class="retention-card__action"
                  [class.is-purchased]="card.preview?.mode === 'purchased'"
                  (click)="openRetentionPurchase(card)"
                  [testId]="'quota-view-retention-action-button-' + ri"
                >
                  {{ card.preview?.mode === 'purchased' ? '續費延長包' : ('quota.view.retention.action' | i18n) }}
                </button>
              </ng-container>
            </nz-card>
            <nz-card
              class="quota-table-card retention-card numeric-addon-card"
              [class.is-loading]="card.previewLoading"
              *ngFor="let card of numericAddonCards; let ni = index"
              [testId]="'quota-view-numeric-addon-card-' + ni"
            >
              <div class="quota-section-head">
                <div>
                  <div class="quota-section-head__title">{{ card.title }}</div>
                  <div class="quota-section-head__meta">{{ card.description }}</div>
                </div>
                <div class="numeric-addon-card__status" *ngIf="!card.previewLoading">
                  <button
                    type="button"
                    class="numeric-addon-card__pending"
                    *ngIf="card.hasPendingOrder"
                    (click)="openNumericAddonPurchase(card)"
                    [disabled]="card.loading"
                    [attr.aria-label]="('quota.view.numeric-addon.modal.tab-unpaid' | i18n) + ' 1'"
                    [testId]="'quota-view-numeric-addon-pending-button-' + ni"
                  >
                    {{ 'quota.view.numeric-addon.modal.tab-unpaid' | i18n }} 1
                  </button>
                  <span class="numeric-addon-card__badge">{{ 'quota.policy.purchase-extension' | i18n }}</span>
                </div>
              </div>
              <ng-container *ngIf="!card.previewLoading; else numericAddonCardLoadingTpl">
                <div class="numeric-addon-card__metrics">
                  <div>
                    <span>{{ 'quota.view.numeric-addon.limit' | i18n }}</span>
                    <strong>{{ card.limitValue }}</strong>
                  </div>
                  <div>
                    <span>{{ 'quota.view.numeric-addon.used' | i18n }}</span>
                    <strong>{{ card.usedValue }}</strong>
                  </div>
                  <div>
                    <span>{{ 'quota.view.numeric-addon.remaining' | i18n }}</span>
                    <strong class="is-remaining">{{ card.remainingValue }}</strong>
                  </div>
                </div>
                <div class="numeric-addon-card__options" *ngIf="card.availableOptions.length">
                  <span class="numeric-addon-card__options-label">{{ 'quota.view.numeric-addon.modal.package' | i18n }}</span>
                  <div>
                    <span class="numeric-addon-card__option" *ngFor="let option of card.availableOptions">{{ option }}</span>
                  </div>
                </div>
                <button
                  nz-button
                  nzType="default"
                  class="retention-card__action numeric-addon-card__action"
                  [nzLoading]="card.loading"
                  [disabled]="card.loading"
                  (click)="openNumericAddonPurchase(card)"
                  [testId]="'quota-view-numeric-addon-action-button-' + ni"
                >
                  {{ 'quota.view.numeric-addon.action' | i18n }}
                </button>
              </ng-container>
            </nz-card>
          </div>

          <ng-template #retentionCardLoadingTpl>
            <div class="retention-card__current retention-card__current--loading">
              <div class="retention-card__loading-line retention-card__loading-line--label"></div>
              <div class="retention-card__loading-line retention-card__loading-line--value"></div>
            </div>
            <div class="retention-card__preview retention-card__preview--loading">
              <div class="retention-card__loading-line retention-card__loading-line--short"></div>
              <div class="retention-card__loading-line"></div>
            </div>
            <div class="retention-card__action-skeleton">
              <div class="retention-card__loading-line retention-card__loading-line--button"></div>
            </div>
          </ng-template>

          <ng-template #numericAddonCardLoadingTpl>
            <div class="numeric-addon-card__skeleton" aria-label="loading">
              <div class="retention-card__loading-line retention-card__loading-line--value"></div>
              <div class="retention-card__loading-line"></div>
              <div class="retention-card__loading-line retention-card__loading-line--short"></div>
              <div class="retention-card__loading-line retention-card__loading-line--button"></div>
            </div>
          </ng-template>

          <ng-template #emptyQuotaTpl>
            <nz-card class="quota-table-card">
              <nz-empty [nzNotFoundContent]="'tenant.detail.quota-usage-empty' | i18n" />
            </nz-card>
          </ng-template>

          <nz-card class="quota-table-card">
            <div class="quota-section-head">
              <div>
                <div class="quota-section-head__title">{{ 'quota.view.records.title' | i18n }}</div>
                <div class="quota-section-head__meta">{{ 'quota.view.records.subtitle' | i18n }}</div>
              </div>
              <div class="quota-section-head__actions">
                <button
                  nz-button
                  nzType="default"
                  [nzLoading]="recentRecordsLoading"
                  (click)="refreshRecentRecords()"
                  testId="quota-view-recent-records-refresh-button"
                >
                  {{ 'quota.view.records.refresh' | i18n }}
                </button>
              </div>
            </div>

            <div class="quota-records-panel" *ngIf="recentRecords.length; else emptyRecordsTpl">
              <div class="quota-records-summary">
                <div class="quota-records-summary__item">
                  <span class="quota-records-summary__label">{{ 'quota.view.records.summary.count' | i18n }}</span>
                  <strong class="quota-records-summary__value">{{ formatNumber(recentRecords.length) }}</strong>
                </div>
                <div class="quota-records-summary__item">
                  <span class="quota-records-summary__label">{{ 'quota.view.records.summary.points' | i18n }}</span>
                  <strong class="quota-records-summary__value" [class]="getRecordAmountClass(recentRecordsPagePointTotal)">
                    {{ formatSignedNumber(recentRecordsPagePointTotal) }}
                  </strong>
                </div>
                <div class="quota-records-summary__item">
                  <span class="quota-records-summary__label">{{ 'quota.view.records.summary.cash' | i18n }}</span>
                  <strong class="quota-records-summary__value">{{ formatCurrency(recentRecordsPageCashTotal) }}</strong>
                </div>
                <div class="quota-records-summary__item">
                  <span class="quota-records-summary__label">{{ 'quota.view.records.summary.latest' | i18n }}</span>
                  <strong class="quota-records-summary__value quota-records-summary__value--time">
                    {{ formatDateTime(recentRecordsLatestTime) }}
                  </strong>
                </div>
              </div>

              <div class="quota-records-panel__viewport">
                <div class="quota-table quota-table--records" [class.is-loading]="recentRecordsLoading">
                  <div class="quota-table__header">
                    <div>{{ 'quota.view.table.time' | i18n }}</div>
                    <div>{{ 'quota.view.records.type' | i18n }}</div>
                    <div>{{ 'quota.view.records.item' | i18n }}</div>
                    <div>{{ 'quota.view.records.desc' | i18n }}</div>
                    <div>{{ 'quota.view.records.status' | i18n }}</div>
                    <div>{{ 'quota.view.records.points' | i18n }}</div>
                    <div>{{ 'quota.view.records.uupon-points' | i18n }}</div>
                    <div>{{ 'quota.view.records.cash' | i18n }}</div>
                  </div>
                  <div class="quota-table__row" *ngFor="let record of recentRecords">
                    <div class="quota-record__time" [attr.data-label]="'quota.view.table.time' | i18n">
                      {{ formatDateTime(record.time) }}
                    </div>
                    <div class="quota-record__type" [attr.data-label]="'quota.view.records.type' | i18n">
                      <span [class]="getRecentRecordTypeBadgeClass(record.type)">{{ record.type }}</span>
                    </div>
                    <div class="quota-record__item" [attr.data-label]="'quota.view.records.item' | i18n" [title]="record.item">
                      {{ record.item }}
                    </div>
                    <div class="quota-record__desc" [attr.data-label]="'quota.view.records.desc' | i18n" [title]="record.description">
                      <span class="quota-record__desc-text">{{ record.description }}</span>
                    </div>
                    <div class="quota-record__status" [attr.data-label]="'quota.view.records.status' | i18n">
                      <span class="status-pill" [class]="'status-pill status-pill--' + record.statusTone">{{ record.status }}</span>
                    </div>
                    <div
                      class="quota-record__amount"
                      [attr.data-label]="'quota.view.records.points' | i18n"
                      [class]="getRecordAmountClass(record.ailePointsAmount)"
                    >
                      {{ formatSignedNumber(record.ailePointsAmount) }}
                    </div>
                    <div
                      class="quota-record__amount"
                      [attr.data-label]="'quota.view.records.uupon-points' | i18n"
                      [class]="getRecordAmountClass(record.uuponPointsAmount)"
                    >
                      {{ formatSignedNumber(record.uuponPointsAmount) }}
                    </div>
                    <div class="quota-record__cash" [attr.data-label]="'quota.view.records.cash' | i18n">
                      {{ formatCurrency(record.cashAmount) }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="quota-records-panel__footer" *ngIf="shouldShowRecentRecordsPagination">
                <div class="quota-records-panel__total">{{ 'common.total-records' | i18n: { total: recentRecordsTotal } }}</div>
                <nz-pagination
                  nzSize="small"
                  [nzPageIndex]="recentRecordsPageIndex"
                  [nzTotal]="recentRecordsTotal"
                  [nzPageSize]="recentRecordsPageSize"
                  [nzShowQuickJumper]="true"
                  (nzPageIndexChange)="onRecentRecordsPageIndexChange($event)"
                  (nzPageSizeChange)="onRecentRecordsPageSizeChange($event)"
                  testId="quota-view-recent-records-pagination"
                />
              </div>

              <div class="quota-records-panel__loading" *ngIf="recentRecordsLoading">
                <nz-spin nzSimple />
              </div>
            </div>

            <ng-template #emptyRecordsTpl>
              <nz-empty [nzNotFoundContent]="'quota.view.records.empty' | i18n" />
            </ng-template>
          </nz-card>
        </div>
      </div>
    </nz-spin>
  </div>
</div>
